import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { AxiosRequestConfig, AxiosError } from 'axios';
import api from '../../lib/axios';
import { handleApiErrorResponse } from '../../helpers';

const axiosBaseQuery = (): BaseQueryFn<
  {
    url: string;
    method: AxiosRequestConfig['method'];
    data?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
    headers?: AxiosRequestConfig['headers']; // Allow passing custom headers
    isDisableErrorToast?: boolean
  },
  unknown,
  unknown
> => async ({ url, method, data, params, headers, isDisableErrorToast = false }: any) => {
  try {
    const result = await api({ url, method, data, params, headers });
    if (!isDisableErrorToast) {
      handleApiErrorResponse({ ...result.data })
    }
    return {
      data: {
        ...result.data,
        meta: { baseRespons: result }
      }
    };
  } catch (axiosError) {
    const err: any = axiosError as AxiosError;
    if (err.response?.data?.error?.message) {
      handleApiErrorResponse({ ...err.response?.data })
    }
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

export default axiosBaseQuery;
